import { ProductCard } from "./ProductCard";

export const ProductRow = ({ title, products, onPick, prefix }) => {
  if (!products.length) return null;
  return (
    <div data-testid={`${prefix}-row`}>
      <p className="font-display text-lg md:text-lg font-semibold mb-3">{title}</p>
      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 snap-x">
        {products.map((p) => (
          <div key={p.id} className="snap-start shrink-0">
            <ProductCard product={p} onPick={onPick} testid={`${prefix}-item-${p.id}`} compact />
          </div>
        ))}
      </div>
    </div>
  );
};
